var e = {
	earnings: {
		title: "Earnings",
		subTitle: "Your payout balances and recent activity at a glance.",
		totalEarned: "Total earned",
		available: "Available",
		upcoming: "Upcoming",
		paidOut: "Paid out",
		outstandingPenalties: "Outstanding penalties",
		upcomingPayouts: "Upcoming payouts",
		noUpcomingPayouts: "No upcoming payouts",
		recentWithdrawals: "Recent withdrawals",
		viewAll: "View all",
		noWithdrawals: "No withdrawals yet",
		bookingCount_one: "{{count}} booking",
		bookingCount_other: "{{count}} bookings"
	},
	penalties: {
		title: "Penalties",
		subTitle: "Cancellation penalties you've incurred, what you've paid, and how it was collected.",
		totalPenalised: "Total penalised",
		paid: "Paid",
		outstanding: "Outstanding",
		tabs: {
			penalties: "Penalties",
			activity: "Settlement activity"
		},
		emptyPenalties: "No cancellation penalties — you're all clear",
		emptyActivity: "No payments yet",
		viewPenalty: "View penalty",
		columns: {
			reservation: "Reservation",
			penalty: "Penalty",
			paid: "Paid",
			outstanding: "Outstanding",
			status: "Status",
			method: "Method",
			date: "Date",
			appliedTo: "Applied to",
			source: "Source",
			amount: "Amount"
		},
		detail: {
			title: "Penalty",
			settleTitle: "Settle penalty",
			settleSubTitle: "Pay this cancellation penalty from your balance or by card.",
			subTitle: "Details of this cancellation penalty.",
			notFound: "Penalty not found.",
			cardFailed: "Your card payment didn't go through. You can try again below.",
			penalisedStay: "Penalised stay",
			guest: "Guest",
			fallbackGuest: "Guest",
			fallbackListing: "Listing",
			confirmingPayment: "Confirming your payment",
			confirmingPaymentHint: "This usually takes just a moment.",
			paymentReceived: "Payment received",
			paymentReceivedHint: "Settling this penalty is taking a little longer than usual — it'll update here shortly.",
			settledToast: "Penalty settled",
			settledToastDescription: "This penalty has been cleared."
		}
	},
	withdrawals: {
		title: "Withdrawals",
		subTitle: "Request withdrawals for your checked-in bookings and track their status.",
		requestWithdrawal: "Request Withdrawal",
		empty: "You haven't requested any withdrawals yet",
		bookingCount_one: "{{count}} booking",
		bookingCount_other: "{{count}} bookings",
		columns: {
			amount: "Amount",
			bookings: "Bookings",
			requested: "Requested",
			status: "Status"
		},
		detail: {
			title: "{{amount}} withdrawal",
			notFound: "Withdrawal not found",
			downloadStatement: "Download payout statement"
		}
	},
	withdrawalMethods: {
		title: "Withdrawal Methods",
		subTitle: "Manage the bank accounts and wallets your withdrawals are paid to.",
		addMethod: "Add Method",
		default: "Default",
		empty: "No withdrawal methods yet — add one to get paid",
		setDefault: "Set default",
		removeTitle: "Remove withdrawal method?",
		removeDescription: "This method will no longer be available for withdrawals. You can add it again later.",
		columns: {
			method: "Method",
			type: "Type",
			accountHolder: "Account holder",
			account: "Account"
		},
		form: {
			addTitle: "Add Withdrawal Method",
			editTitle: "Edit Withdrawal Method",
			saveChanges: "Save Changes",
			addMethod: "Add Method",
			updatedToast: "Withdrawal method updated",
			addedToast: "Withdrawal method added",
			saveErrorToast: "Could not save method",
			methodType: "Method type",
			methodBankTransfer: "Bank transfer",
			methodInstaPay: "InstaPay",
			methodWallet: "Wallet",
			label: "Label (optional)",
			labelPlaceholder: "e.g. My NBE account",
			accountHolder: "Account holder name",
			accountHolderPlaceholder: "Full name on the account",
			bankName: "Bank name",
			bankNamePlaceholder: "e.g. National Bank of Egypt",
			accountNumber: "Account number",
			accountNumberPlaceholder: "Account number",
			iban: "IBAN (optional)",
			ibanPlaceholder: "EG…",
			swift: "SWIFT / BIC (optional)",
			swiftPlaceholder: "8–11 characters",
			instaPayAddress: "InstaPay address / number",
			instaPayPlaceholder: "InstaPay handle or number",
			walletNumber: "Wallet number",
			walletNumberPlaceholder: "Mobile wallet number",
			setAsDefault: "Set as default",
			setAsDefaultDescription: "Use this method by default for new withdrawals.",
			validation: {
				accountHolderRequired: "Account holder is required",
				bankNameRequired: "Bank name is required",
				accountOrIbanRequired: "Account number or IBAN is required",
				fieldRequired: "This field is required"
			}
		}
	}
};
//#endregion
export { e as default };
